import guideSerializer from '@serializers/guideSerializer.js'
import { KEYS_GUIDES } from '@config/storeKeys.js'
import { store } from '@stores'
import { computed } from 'vue'

const { addToStoreData, updateStore, generateId, getStore } = store()

export default function () {
  function addGuides(gameNameId, guides, query) {
    updateStore(generateId(KEYS_GUIDES, gameNameId), {
      ...guideSerializer.transform(guides),
      query,
    })
  }

  function getGuides(gameId) {
    return getStore(generateId(KEYS_GUIDES, gameId))
  }

  function addGuide(gameId, guide) {
    const _guide = guideSerializer.transform(guide)
    addToStoreData(generateId(KEYS_GUIDES, gameId), _guide)
    return _guide
  }

  function getGuideId(guideNameId, gameNameId) {
    guideNameId = guideNameId?.toLowerCase()
    const guides = getStore(generateId(KEYS_GUIDES, gameNameId))
    const guide = guides.value?.data?.find(
      (g) => g.name_id.toLowerCase() === guideNameId
    )
    return guide ? guide.id : null
  }

  function getGuide(gameId, guideNameId) {
    const guides = getStore(generateId(KEYS_GUIDES, gameId))

    return computed(() =>
      guides.value?.data?.find((guide) => guide.name_id === guideNameId)
    )
  }

  function removeGuides(gameId) {
    updateStore(generateId(KEYS_GUIDES, gameId))
  }

  // Stub for shared components
  function getFeaturedGuides() {
    return { value: null }
  }

  function addFeaturedGuides() {}

  return {
    addFeaturedGuides,
    getFeaturedGuides,
    removeGuides,
    getGuideId,
    addGuides,
    getGuides,
    getGuide,
    addGuide,
  }
}
